<mat-chip-listbox multiple [ngModel]="selectedButtons" (ngModelChange)="setSelectedButtons($event)">
  <mat-chip-option *ngFor="let button of buttons" [value]="button">{{button.label}}</mat-chip-option>
</mat-chip-listbox>
